import { ChangeDetectorRef, Directive, Inject, Input, OnInit } from '@angular/core';
import { LOCALE_ID } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { OnDestroyHandler } from 'apps/klickdata/src/app/shared/onDestroy-handler/onDestroy-handler';
import { takeUntil, tap } from 'rxjs';
import { Utils } from '@klickdata/core/util';

@Directive()
export abstract class customFieldsBase extends OnDestroyHandler implements OnInit {
    @Input() customFieldForm: FormGroup;
    Utils = Utils;
    constructor(protected cdr: ChangeDetectorRef, @Inject(LOCALE_ID) protected localeId: string) {
        super();
    }
    ngOnInit(): void {
        this.customFieldForm.valueChanges
            .pipe(
                takeUntil(this.destroy),
                tap(() => this.cdr.markForCheck())
            )
            .subscribe();
    }
}
